import Card from "@/components/ui/card";
import { useAuth } from "@/contexts/auth-provider/useAuth";
import { useGetMe } from "@/queries/me";
import {
  Avatar,
  AvatarFallback,
  Button,
  Heading,
  Icon,
} from "@elaniintc/goes-design-system";
import ProfileForm from "./profile-form";
import { type ReactNode } from "react";

const IconWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="size-7 rounded-lg bg-neutral-background border border-neutral-quiet flex items-center justify-center text-body">
      {children}
    </div>
  );
};

const Profile = () => {
  const { keycloak, authUser } = useAuth();
  const { data } = useGetMe();

  const user = data?.data;

  const onUpdatePassword = () => {
    keycloak.login({
      action: "UPDATE_PASSWORD",
    });
  };
  // if (!data) {
  //   return null;
  // }

  return (
    <div className="grid grid-cols-1 laptop:grid-cols-[1fr_1fr] gap-3">
      <div
        className="flex flex-col gap-4 w-full p-4"
        data-testid="profile-info-section"
      >
        <Avatar size="xl" data-testid="profile-avatar">
          <AvatarFallback color="action">
            {user?.name?.charAt(0).toUpperCase() ||
              authUser?.given_name?.charAt(0).toUpperCase() ||
              "U"}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col items-start gap-2">
          {/* <Heading variant="h5">{data?.user.name}</Heading> */}
          <Heading
            variant="h5"
            data-testid="profile-name"
          >{`${user?.name || authUser?.given_name || ""} ${user?.last_name || authUser?.family_name || ""}`}</Heading>
          <p
            className="text-body-quiet font-normal"
            data-testid="profile-job-title"
          >
            Gerente de proyectos
          </p>
        </div>
        <div className="w-full h-px border-t border-neutral-quiet" />
        <div>
          <div className="flex items-center gap-3">
            <IconWrapper>
              <Icon type="far" name="user-shield" />
            </IconWrapper>

            <span className="text-body font-normal" data-testid="profile-role">
              Administrador
            </span>
          </div>
        </div>
        <div className="w-full h-px border-t border-neutral-quiet" />
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <IconWrapper>
                <Icon type="far" name="id-card" />
              </IconWrapper>
              <span className="text-body font-normal" data-testid="profile-dui">
                {user?.dui || ""}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <IconWrapper>
                <Icon type="far" name="envelope" />
              </IconWrapper>
              <span
                className="text-body font-normal"
                data-testid="profile-email"
              >
                {user?.email || ""}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <IconWrapper>
                <Icon type="far" name="phone" />
              </IconWrapper>
              <span
                className="text-body font-normal"
                data-testid="profile-phone"
              >
                {user?.phone_number?.number
                  ? `+(${user?.phone_number.calling_code}) ${user?.phone_number.number}`
                  : ""}
              </span>
            </div>
          </div>
        </div>
        <div className="w-full h-px border-t border-neutral-quiet" />
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-3">
            <IconWrapper>
              <Icon type="far" name="building" />
            </IconWrapper>
            <span
              className="text-body font-normal"
              data-testid="profile-organization"
            >
              Gobierno de el salvador
            </span>
          </div>
          <div className="flex items-center gap-3">
            <IconWrapper>
              <Icon type="far" name="users" />
            </IconWrapper>
            <span
              className="text-body font-normal"
              data-testid="profile-department"
            >
              Gestión de Proyectos
            </span>
          </div>
        </div>
        <div className="w-full h-px border-t border-neutral-quiet" />
        <div>
          <Button
            variant="tertiary"
            className="h-10 w-full"
            onClick={onUpdatePassword}
            data-testid="change-password-button"
          >
            Cambiar contraseña
            <Icon type="far" name="lock" className="text-current text-sm" />
          </Button>
        </div>
      </div>
      <Card className="p-6" data-testid="profile-form-section">
        <ProfileForm
          id={user?.id || ""}
          data={{
            name: user?.name || authUser?.given_name || "",
            last_name: user?.last_name || authUser?.family_name || "",
            phone_number: user?.phone_number,
            email: user?.email || "",
            dui: user?.dui || "",
            department_id: user?.department_id || "",
            registered_position_id: user?.registered_position_id || "",
            assigned_institution_id: user?.assigned_institution_id || "",
          }}
        />
      </Card>
    </div>
  );
};

export default Profile;
